// ======================
// Concatenate Classnames
// ======================
//
// Support className as an array:
// force classname prop into an array (possibly of arrays) then flatten

/*
    // To use spread the new array into aphrodite's `css` function

    function Component ({ className, ...props }) {
        props.className = css(
            classes.component,
            ...concatClassnames(className)
        )

        return <Component {...props} />
    }
*/

export function concatClassnames(className) {
  return [className].reduce((a, b) => {
    return a.concat(b)
  }, [])
}

export default concatClassnames
